// extracted by mini-css-extract-plugin
export default {"root":"CaseCloudFilesItemSkeleton_root__vBvHq"};